import React from 'react';
import i18next from 'core/i18n';
import { RegularTitle } from '@indigo-ag/component-module';

import { NewPage } from 'core/components';

const HomePageComponent: React.FunctionComponent = () => {
  return (
    <NewPage title={i18next.t('homePage_header')}>
      <RegularTitle>Admin dashboard page</RegularTitle>
    </NewPage>
  );
};

export const HomePage = HomePageComponent;
